module.exports = __webpack_public_path__ + "media/images/gift-thanks-title-candy@2x-39ccb5bbb82c1dc0bfeed19f4d326d20.png";